import { z } from 'zod'

import { Locales } from './locale'

export const CountryLanguageZ = z.object({
	code: z.enum(Locales),
	name: z.string(),
})

export type CountryLanguage = z.infer<typeof CountryLanguageZ>
